import { onError } from 'apollo-link-error';

export const errorLink = onError(({ networkError, graphQLErrors = [] }) => {
  // if (networkError) window.alert('Network error?');
});
